<webmodule-order-panel>
  <ng-container content>

    @if (requestResponse() && 200 === requestResponse()?.status) {
      <div class="grid grid-cols-5 gap-4 py-4">
        <div class="col-span-5">
          <h2>{{ requestResponse()?.message }}</h2>
          @if (hasSessionResult()) {
            <webmodule-order-alert [title]="'block.zipcode.alert.restore-session' | translate" variation="info"></webmodule-order-alert>
          }
        </div>
        <div class="col-span-5 md:col-span-2">
          <dl class="pb-2">
            <dt class="font-semibold">Jouw adres</dt>
            @if (address(); as address) {
              <dd>{{ address.street }} {{ address.houseNumber }} {{ address.houseNumberAddition }}</dd>
              <dd>{{ address.postcode }} {{ address.city }}</dd>
            }
          </dl>
          <button (click)="reset()" class="inline link">{{ 'block.zipcode.button-reset' | translate }}</button>
        </div>
        @if (supplier(); as supplier) {
          <div class="col-span-5 md:col-span-2">
            <div [innerHTML]="'block.zipcode.network-supplied-by' | translate:{supplier: supplier.name}"></div>
            <img [src]="supplier.logo" [alt]="supplier.name" />
          </div>
        }
      </div>
    } @else {
      <form [formGroup]="form" novalidate>
        <fieldset [disabled]="loading()">
          <legend class="sr-only">Postcode beschikbaarheid controleren</legend>
          <div class="grid md:grid-cols-5 gap-4">
            <div class="col-span-5">
              <h2>{{ 'block.zipcode.title' | translate}}</h2>
            </div>
            <div class="col-span-5 md:col-span-2" [innerHtml]="'block.zipcode.description' | translate"></div>
            <div class="col-span-5 md:col-span-3 grid md:grid-cols-5 gap-2">
              <div class="input-group">
                <label class="sr-only label" for="zipcode">{{ 'common.input.zipcode.label' | translate }}</label>
                <div>
                  <input class="control"
                         formControlName="zipcode"
                         id="zipcode"
                         name="zipcode"
                         [placeholder]="'common.input.zipcode.placeholder' | translate"
                         type="text">
                </div>
              </div>
              <div class="input-group">
                <label class="sr-only label" for="houseNumber">{{ 'common.input.houseNumber.label' | translate }}</label>
                <div>
                  <input class="control"
                         formControlName="houseNumber"
                         id="houseNumber"
                         name="houseNumber"
                         [placeholder]="'common.input.houseNumber.placeholder' | translate"
                         type="number">
                </div>
              </div>
              <div class="input-group">
                <label class="sr-only label" for="additional">{{ 'common.input.addition.label' | translate }}</label>
                <div>
                  <input class="control"
                         formControlName="addition"
                         id="additional"
                         name="additional"
                         [placeholder]="'common.input.addition.placeholder' | translate"
                         type="text">
                </div>
              </div>
              <button (click)="check()"
                      [disabled]="form.invalid"
                      class="button primary md:col-span-2"
                      type="submit">
                {{ 'block.zipcode.button-check' | translate }}
              </button>
            </div>
          </div>
        </fieldset>
      </form>
      @if (requestResponse(); as response) {
        @if (response.status === 404) {
          <webmodule-order-alert [title]="response.message | translate" variation="info"></webmodule-order-alert>
        } @else {
          <webmodule-order-alert [title]="response.message | translate" variation="error"></webmodule-order-alert>
        }
      }
    }


    @if (false) {
      <div class="relative py-6">
        <div aria-hidden="true" class="absolute inset-0 flex items-center">
          <div class="w-full border-t border-gray-200"></div>
        </div>
      </div>
      <div class="grid grid-cols-1 gap-4">
        <div class="">
          <h3>Heb je al een abonnement bij Multifiber?</h3>
          <p>Combineer Multifiber Internet met Mobiel en krijg korting! <a href="#">Meer weten over de combinatie korting</a></p>
        </div>
        <div class="flex gap-4 items-center">
          <button (click)="setType('NEW_CUSTOMER')"
                  [ngClass]="{ 'active': selectedType() === 'NEW_CUSTOMER' }"
                  class="button secondary outline">Nee, ik ben een nieuwe klant</button>
          <button (click)="setType('MOBILE_ONLY')"
                  [ngClass]="{ 'active': selectedType() === 'MOBILE_ONLY' }"
                  class="button secondary outline">Ja, ik heb internet (en TV)</button>
          <button (click)="setType('INTERNET_ONLY')"
                  [ngClass]="{ 'active': selectedType() === 'INTERNET_ONLY' }"
                  class="button secondary outline">Ja, ik heb mobiel abonnement</button>
        </div>
      </div>
    }
  </ng-container>
</webmodule-order-panel>
